import React from 'react';
import Sidenavigation1 from '../../../layouts/Sidenavigation1';
import Topnavigation from '../../../layouts/Topnavigation';

import { TheMasterContextProvider } from '../../../MyContexts/Master_Context';
import BuisUserprofileContent from './BuisUserprofileContent';

const BuisUserprofile = (props) => {
    return (
        <div className="ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar">
            <TheMasterContextProvider>
               
                    <Sidenavigation1 />
                    <main className="body-content">
                        <Topnavigation />
                        <BuisUserprofileContent />
                    </main>
               
            </TheMasterContextProvider>
        </div>
    );
}

export default BuisUserprofile;